import ShortErrorInfo from './ShortErrorInfo';

export default ShortErrorInfo;
